import styles from './style.module.css';
import { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router';
import CustomBreadcrumb from '../../../components/CustomBreadcrumb';
import { CustomButton } from '../../../components/CustomButton';
import TableActionsContainer from '../../../components/CustomTable/TableActionsContainer';
import { Text } from '../../../components/Text';
import CustomInputText from '../../../components/common/CustomInputText';
import CustomDropdown from '../../../components/common/CustomDropdown';
import CustomInputTextArea from '../../../components/common/CustomInputTextArea';
import CustomInputPrice from '../../../components/common/CustomInputPrice';
import { Image } from 'primereact/image';

import { useRef } from 'react';
import {
  changeMode,
  getProductbyId,
  resetAll,
  updateProduct,
} from '../../../reducers/productTableSlice';
import { createProduct } from '../../../reducers/wca/product/product-action';
import { useLayout } from '../../../context/LayoutContext';
import CustomSaveModel from '../../../components/CustomeSaveModel';
import CONSTANTS from '../../../config/Constants';
import * as Messag from '../../../config/ToastMessage';
import { v4 as uuidv4 } from 'uuid';
import Notice from '../../../components/Alert/Notice';
import { changeShowNotice } from '../../../reducers/appSlice';
import modulesName from '../../../roles/modulesName';
import permissions from '../../../roles/permissions';
import { useUtility } from '../../../context/UtilityContext';
import { API_GET_IMG_URL, API_UPLOAD_IMG } from '../../../api/chat.service';

const statusOption = [
  { key: 'in stock', value: 'in stock' },
  { key: 'out of stock', value: 'out of stock' },
];
//

const currencyOptions = [
  { label: 'INR (₹)', value: 'INR' },
  { label: 'USD ($)', value: 'USD' },
  { label: 'EUR (€)', value: 'EUR' },
];

function NewProductWCA() {
  const [defaultFormValues, setdefaultFormValues] = useState({});
  const [mainImage, setMainImage] = useState(null);
  const [additionalImages, setAdditionalImages] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { selectedMetadataId } = useUtility();

  const { toast, setLoading } = useLayout(null);
  const { accesskey } = useSelector((state) => state.authenticate);
  const { id } = useParams();

  const { loading, mode, selectedProduct } = useSelector((state) => state.productTableWCA);

  const { showNotice } = useSelector((state) => state.application);

  const breadcumbHome = { label: 'Products', url: '/products/list' };
  const breadcumnList = [{ label: `${id ? 'Update' : 'New'} Product`, url: '#' }];

  const defaultValues = {
    productName: '',
    category: '',
    price: undefined,
    salePrice: undefined, // ✅ NEW
    status: 'in stock',
    SKUCode: '',
    desc: '',
    currency: 'INR', // ✅ default
    url: '', // ✅ NEW
  };

  //function form get error message
  const getFormErrorMessage = (name) => {
    return errors[name] && <small className="p-error">{errors[name].message}</small>;
  };

  // MAIN IMAGE (single)
  const handleMainImage = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setMainImage({
      file,
      preview: URL.createObjectURL(file),
    });

    e.target.value = null; // 🔥 important
  };

  const removeMainImage = () => {
    setMainImage(null);
  };

  // ADDITIONAL IMAGES (multiple)
  const handleAdditionalImages = (e) => {
    const files = [...e.target.files];

    const newImgs = files.map((file) => ({
      id: uuidv4(),
      file,
      preview: URL.createObjectURL(file),
    }));

    setAdditionalImages((prev) => [...prev, ...newImgs]);
  };

  const removeAdditionalImage = (img) => {
    setAdditionalImages((prev) => prev.filter((p) => p.id !== img.id));
  };

  const typechecker = (selectedImage) => {
    if (selectedImage.type === 'image/png' || selectedImage.type === 'image/jpeg') {
      return true;
    }
    return false;
  };

  const {
    control,
    formState: { errors, isValid },
    handleSubmit,
    reset,
    setValue,
    getValues,
  } = useForm({ defaultValues });

  useEffect(() => {
    setLoading(loading);
  }, [loading]);

  const [showSave, setShowSave] = useState(false);

  const uploadImageToS3 = async (file) => {
    try {
      // 1. Get signed URL
      const respUrl = await API_GET_IMG_URL();

      const uploadUrl = respUrl.data.src;
      const fileUrl = respUrl.data.url;
      console.log(' file.type', file.type);

      // 2. Upload file to S3
      await API_UPLOAD_IMG(uploadUrl, file, file.type);

      // 3. Return public URL
      return fileUrl;
    } catch (err) {
      console.log('S3 Upload Error:', err);
      throw err;
    }
  };

  const onSubmit = async (data) => {
    try {
      if (!mainImage) {
        toast.current.show({
          severity: 'error',
          detail: 'Main product image is required',
        });
        return;
      }

      // Upload main image only if new
      let mainImageUrl = mainImage?.preview;

      if (mainImage?.file) {
        mainImageUrl = await uploadImageToS3(mainImage.file);
      }

      // Upload only NEW additional images
      const additionalUrls = await Promise.all(
        additionalImages.map(async (img) => {
          if (img.file) {
            return await uploadImageToS3(img.file);
          }
          return img.preview; // already uploaded image
        }),
      );

      const payload = {
        retailerId: data.SKUCode,
        name: data.productName,
        description: data.desc,
        price: data.price,
        salePrice: data.salePrice,
        category: data.category,
        availability: data.status,
        currency: data.currency,
        url: data.url.toLowerCase(),
        imageUrl: mainImageUrl,
        additionalImageUrls: additionalUrls,
      };

      console.log('payload', payload);
      // return;

      dispatch(
        createProduct({
          metadataid: selectedMetadataId,
          data: payload,
        }),
      )
        .unwrap()
        .then(() => {
          let Message_Success = Messag.Add_Product_ToastSuccessMessage;
          toast.current.show({
            severity: 'success',
            detail: Message_Success,
          });
          onReset();
          setShowSave(false);
          navigate('/products/list');
        });
    } catch (err) {
      toast.current.show({
        severity: 'error',
        detail: err.message,
      });
      setShowSave(false);
    }
  };

  useEffect(() => {
    dispatch(changeShowNotice(true));
  }, []);

  const alertText = () => {
    return <div>{CONSTANTS.PRODUCT_SAVE_CONFIMATION}</div>;
  };

  const { setAlert, navigation } = useUtility();

  useEffect(() => {
    return () => {
      setAlert(false);
    };
  }, []);

  useEffect(() => {
    if (id) {
      dispatch(changeMode('update'));

      dispatch(getProductbyId({ productId: id })).then((res) => {
        const prodData = res?.payload;

        // ✅ Set form fields
        reset({
          productName: prodData?.name || '',
          category: prodData?.category || '',
          price: prodData?.price || 0,
          salePrice: prodData?.salePrice || 0,
          status: prodData?.availability || '',
          SKUCode: prodData?.retailerId || '',
          desc: prodData?.description || '',
          currency: prodData?.currency || 'INR',
          url: prodData?.url || '',
        });

        // ✅ Set MAIN image (from API)
        if (prodData?.imageUrl) {
          setMainImage({
            file: null, // no file (already uploaded)
            preview: prodData.imageUrl,
            isExisting: true,
          });
        }

        // ✅ Set ADDITIONAL images
        if (prodData?.additionalImageUrls?.length) {
          const mapped = prodData.additionalImageUrls.map((url, index) => ({
            id: index,
            file: null,
            preview: url,
            isExisting: true,
          }));

          setAdditionalImages(mapped);
        }
      });

      const sec = getValues();
      setdefaultFormValues({ ...sec });
    }

    return () => {
      dispatch(resetAll());
    };
  }, [id]);

  const onReset = () => {
    setValue('productName', defaultFormValues.name);
    setValue('category', defaultFormValues.category);
    setValue('price', defaultFormValues.price);
    setValue('salePrice', defaultFormValues.salePrice);
    setValue('status', defaultFormValues.availability);
    setValue('SKUCode', defaultFormValues.retailerId);
    setValue('desc', defaultFormValues.description);
    setValue('currency', defaultFormValues.currency);
    setValue('url', defaultFormValues.url);
    setMainImage(null);
    setAdditionalImages([]);
  };

  return (
    <div>
      <CustomBreadcrumb home={breadcumbHome} itemslist={breadcumnList} />
      <CustomSaveModel
        showSave={showSave}
        header={alertText()}
        dialogFooter={
          <div className="flex justify-content-end ">
            <CustomButton
              label="Cancel"
              varient="cancel"
              autofocus={true}
              onClick={() => setShowSave(false)}
            />
            <CustomButton label="Confirm" varient="filled" onClick={handleSubmit(onSubmit)} />
          </div>
        }
        onHide={() => setShowSave(false)}
      />
      <div className="m-3">
        {showNotice && <Notice message={'Products will be uploaded every midnight.'} />}
        <TableActionsContainer>
          <div className="hidden sm:hidden md:flex justify-content-between align-items-center gap-3 flex-wrap">
            <Text type={'heading'}>Product Information</Text>
            <div className="flex gap-2">
              <CustomButton
                varient="text"
                label={'Cancel'}
                onClick={() => navigate('/products/list')}
              />
              <CustomButton
                varient="outline"
                label={'Reset'}
                onClick={() => (id ? onReset() : reset())}
              />
              {accesskey[modulesName.PRODUCT]?.includes(
                `${mode == 'update' ? permissions.UPDATE : permissions.CREATE}`,
              ) && (
                <CustomButton
                  varient="filled"
                  label={mode == 'update' ? 'Update' : 'Save'}
                  onClick={() => setShowSave(true)}
                  disabled={!isValid || !mainImage}
                />
              )}
            </div>
          </div>
          {/* ***** For Mobile Screens ***** */}
          <div className="hidden sm:flex md:hidden flex flex-column justify-content-between align-items-start gap-3 flex-wrap">
            <div className="flex justify-content-start">
              <Text type={'heading'}>Product Information</Text>
            </div>
            <div className="flex justify-content-end  w-full ">
              <div className="flex gap-3">
                <CustomButton
                  varient="text"
                  label={'Cancel'}
                  onClick={() => navigation('/products/list')}
                />
                <CustomButton
                  varient="outline"
                  label={'Reset'}
                  onClick={() => (id ? onReset() : reset())}
                />
                {accesskey[modulesName.PRODUCT]?.includes(
                  `${mode == 'update' ? permissions.UPDATE : permissions.CREATE}`,
                ) && (
                  <CustomButton
                    varient="filled"
                    label={mode == 'update' ? 'Update' : 'Save'}
                    disabled={!isValid || !mainImage}
                    onClick={() => setShowSave(true)}
                  />
                )}
              </div>
            </div>
          </div>
        </TableActionsContainer>
      </div>
      <div className={`mx-3 p-3 ${styles['form-container']}`}>
        <form
          onSubmit={(e) => e.preventDefault()} // ❌ prevent auto submit
          onChange={() => setAlert(true)}
        >
          <div className="w-full flex flex-column lg:flex-row flex-wrap gap-2 mb-4">
            <div className="flex-1">
              <CustomInputText
                placeholer="Product Name"
                label="Name "
                required={true}
                control={control}
                name="productName"
                maxLength={200}
              />
              {getFormErrorMessage('productName')}
            </div>
            <div className="flex-1">
              <CustomInputText
                placeholer="category"
                label="category "
                required={true}
                control={control}
                name="category"
                maxLength={200}
              />
              {getFormErrorMessage('category')}
            </div>
            <div className="flex-1">
              <CustomInputText
                placeholer="xx-0000"
                label="SKU Code"
                required={true}
                control={control}
                name="SKUCode"
                rules={{
                  pattern: {
                    value: /^[a-zA-Z0-9-]*$/,
                    message: 'Only alphanumeric characters without white spaces are allowed.',
                  },
                }}
                style={{ textTransform: 'uppercase' }}
                maxLength={20}
                disable={id ? true : false}
              />
              {getFormErrorMessage('SKUCode')}
            </div>

            <div className="flex-1">
              <CustomDropdown
                label="Stock "
                placeholder="Choose"
                control={control}
                name="status"
                optionLabel="key"
                optionValue="value"
                isMandatory={true}
                options={statusOption}
              />
              {getFormErrorMessage('status')}
            </div>
          </div>
          <div className="w-full flex flex-wrap align-items-center gap-2 mb-4">
            <div className="flex-1">
              <CustomDropdown
                label="Currency"
                placeholder="Select Currency"
                control={control}
                name="currency"
                optionLabel="label"
                optionValue="value"
                options={currencyOptions}
                isMandatory={true}
              />
            </div>
            <div className="flex-1">
              <CustomInputPrice
                label={'Price'}
                placeholder="Enter Price"
                control={control}
                name="price"
                isMandatory={true}
                mode="decimal"
              />
            </div>
            <div className="flex-1">
              <CustomInputPrice
                label={'Sale Price'}
                placeholder="Enter Sale Price"
                control={control}
                name="salePrice"
                mode="decimal"
                isMandatory={true}
              />
            </div>
            <div className="flex-1">
              <CustomInputText
                placeholer="https://example.com"
                label="Product URL"
                control={control}
                name="url"
                capitalize={false}
              />
            </div>
          </div>

          <div className="w-full lg:w-6 mb-4">
            <CustomInputTextArea
              label="Descriptions "
              placeholder="Product description ..."
              name="desc"
              control={control}
              className="firstcapital"
              isMandatory={false}
              rules={{
                required: false,
                pattern: {
                  value: /[ a-z]/,
                  message: 'Description must have upper and lower case characters',
                },
              }}
            />
            {getFormErrorMessage('desc')}
          </div>

          <div className="mb-4">
            <div className="mb-2">
              <Text type="sub-heading">Main Product Image</Text>
            </div>

            <input
              type="file"
              accept="image/*"
              hidden
              id="mainImageInput"
              onChange={handleMainImage}
            />

            <div
              style={{
                position: 'relative',
                border: '2px dashed #5E5E5E',
                height: '180px',
                width: '180px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                cursor: 'pointer',
                borderRadius: '10px',
                background: '#EDEDED',
              }}
            >
              {mainImage ? (
                <>
                  <Image src={mainImage.preview} alt="main" preview width="180px" height="180px" />

                  {/* ❌ Remove Button */}
                  <button
                    type="button"
                    onClick={removeMainImage}
                    style={{
                      position: 'absolute',
                      top: -8,
                      right: -8,
                      background: 'red',
                      color: '#fff',
                      border: 'none',
                      borderRadius: '50%',
                      width: '22px',
                      height: '22px',
                      cursor: 'pointer',
                      fontSize: '12px',
                    }}
                  >
                    ×
                  </button>
                </>
              ) : (
                <div onClick={() => document.getElementById('mainImageInput').click()}>
                  <Text>Upload Main Image</Text>
                </div>
              )}
            </div>
          </div>

          <div className="mb-4">
            <div className="mb-2">
              <Text type="sub-heading">Additional Images</Text>
            </div>

            <input
              type="file"
              accept="image/*"
              hidden
              multiple
              id="additionalImageInput"
              onChange={handleAdditionalImages}
            />

            <div className="flex gap-3 flex-wrap mb-2">
              {additionalImages.map((img) => (
                <div key={img.id} style={{ position: 'relative' }}>
                  <Image
                    src={img.preview}
                    preview
                    alt="additional"
                    width="80px"
                    height="80px"
                    style={{ borderRadius: '8px', objectFit: 'cover' }}
                  />

                  <button
                    type="button"
                    onClick={() => removeAdditionalImage(img)}
                    style={{
                      position: 'absolute',
                      top: -5,
                      right: -5,
                      background: 'red',
                      color: '#fff',
                      border: 'none',
                      borderRadius: '50%',
                      width: '18px',
                      height: '18px',
                      cursor: 'pointer',
                    }}
                  >
                    ×
                  </button>
                </div>
              ))}
            </div>

            <button
              type="button"
              onClick={() => document.getElementById('additionalImageInput').click()}
              className="p-2 mb-2"
              style={{ border: '1px dashed #5E5E5E', background: '#EDEDED' }}
            >
              Add Images
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default NewProductWCA;
